//PRODUCTS
export const SearchProducts = `query SearchProducts($input: SearchInput!) {
  searchProducts(input: $input) {
    catalogResults {
      data {
        id
        imageId
        name
      }
      id
      type
    }
    count
    data
    facets {
      id
      values {
        count
        id
      }
    }
    limit
    page
    results {
      attributes {
        imageIds
        productAttribute {
          id
          name
          tableTemplate {
            columns {
              id
              name
            }
            rows {
              id
              name
            }
          }
          translations {
            description
            locale
            name
            options {
              id
              name
            }
          }
          type
        }
        productAttributeOption {
          id
          name
        }
        value
      }
      averageRating
      baseUnit {
        baseAmount
        type
        unit {
          id
          name
          translations {
            description
            locale
            name
          }
        }
      }
      brand {
        id
        imageId
        name
        slug
        translations {
          description
          locale
          name
          slug
        }
      }
      campaignOffers {
        availableSalesChannelIds
        currencyCodes
        id
      }
      campaigns {
        applicablePrice
        applyCampaignToProductPrice
        buyXThenGetY {
          buyX {
            amount
            applyByQuantity
            filter {
              idList
              type
            }
          }
          getY {
            amount
            automaticallyAddItemToCart
            discountRatio
          }
          maxUsagePerOrder
        }
        currencyCodes
        dateRange {
          end
          start
        }
        fixedDiscount {
          amount
          filters {
            idList
            type
          }
          lineItemQuantityRange {
            max
            min
          }
          priceRange {
            max
            min
          }
          shouldMatchAllConditions
        }
        id
        includeDiscountedProducts
        salesChannelIds
        tieredDiscount {
          isApplyByCartAmount
          rules {
            amount
          }
          shouldMatchAllConditions
        }
        title
        type
      }
      categories {
        id
        name
        path {
          id
          name
          slug
        }
        slug
        translations {
          description
          locale
          name
          slug
        }
      }
      createdAt
      customerReviewSummaries {
        averageRating
        reviewCount
        storefrontId
      }
      deleted
      description
      dynamicPriceListIds
      groupVariantsByVariantTypeId
      hiddenSalesChannelIds
      id
      metaData {
        canonicals
        description
        disableIndex
        metadataOverrides {
          description
          language
          pageTitle
          storefrontId
          storefrontRegionId
        }
        pageTitle
        redirectTo
        slug
        translations {
          description
          locale
          pageTitle
          slug
        }
      }
      name
      productGroup {
        groupKey
        id
        name
        order {
          orderAttributeId
          value
        }
        translations {
          locale
          values {
            id
            name
            value
          }
        }
        values {
          id
          name
          value
        }
      }
      productOptionSetId
      productVariantTypes {
        order
        variantType {
          id
          name
          selectionType
          translations {
            locale
            name
            values {
              id
              name
            }
          }
          values {
            colorCode
            id
            name
            thumbnailImageId
          }
        }
        variantValueIds
      }
      productVolumeDiscountId
      reviewCount
      salesChannelIds
      salesChannels {
        id
        maxQuantityPerCart
        minQuantityPerCart
        productVolumeDiscountId
        quantitySettings
        status
      }
      shortDescription
      stars {
        count
        star
      }
      tags {
        id
        name
        translations {
          description
          locale
          name
        }
      }
      translations {
        description
        locale
        name
      }
      type
      updatedAt
      variants {
        barcodeList
        baseBundlePrices {
          buyPrice
          campaignPrice {
            campaignId
            campaignPrice
          }
          currency
          currencyCode
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        bundleSettings {
          maxBundleQuantity
          minBundleQuantity
          products {
            addToBundleBasePrice
            discountRatio
            filteredVariantIds
            id
            maxQuantity
            minQuantity
            order
            productId
            quantity
          }
        }
        deleted
        id
        images {
          fileName
          id
          isMain
          isVideo
          order
        }
        isActive
        prices {
          buyPrice
          currency
          currencyCode
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        sellIfOutOfStock
        sku
        stocks {
          stockCount
          stockLocationId
        }
        subscriptionPlan {
          name
          periods {
            discount {
              amount
              type
            }
            id
            maxOrders
            paymentType
          }
          subscriptionPlanId
        }
        unit {
          amount
          type
        }
        variantValues {
          variantTypeId
          variantValueId
        }
        weight
      }
      weight
    }
    suggestions {
      brandId
      categoryId
      id
      term
    }
    totalCount
  }
}`;
export const getProductFilterData = `query GetProductFilterData($brandId: String, $categoryId: String, $locale: String) {
  getProductFilterData(brandId: $brandId, categoryId: $categoryId, locale: $locale) {
    categories {
      categoryPath
      categoryPathItems {
        createdAt
        deleted
        description
        id
        imageId
        isAutomated
        name
        updatedAt
      }
      conditions {
        conditionType
        method
        valueList
      }
      createdAt
      deleted
      description
      id
      imageId
      isAutomated
      metaData {
        canonicals
        createdAt
        deleted
        description
        disableIndex
        id
        metadataOverrides {
          description
          language
          pageTitle
          storefrontId
          storefrontRegionId
        }
        pageTitle
        redirectTo
        slug
        targetId
        targetType
        translations {
          description
          locale
          pageTitle
          slug
        }
        updatedAt
      }
      name
      orderType
      parentId
      salesChannelIds
      salesChannels {
        id
        status
      }
      shouldMatchAllConditions
      translations {
        description
        locale
        name
      }
      updatedAt
    }
    disabledSortTypes
    filters {
      customValues
      displayType
      id
      isFacetFilter
      isMultiSelect
      key
      name
      order
      settings {
        customSortedValues
        showCollapsedOnDesktop
        showCollapsedOnMobile
        sortType
        useAndFilter
      }
      type
      values {
        colorCode
        id
        key
        name
        slug
        thumbnailImageId
      }
    }
  }
}`;

//CUSTOMER
export const GetMyCustomer = `query GetMyCustomer {
  getMyCustomer {
    accountStatus
    accountStatusUpdatedAt
    addresses {
      addressLine1
      addressLine2
      city {
        code
        id
        name
      }
      company
      country {
        code
        id
        iso2
        iso3
        name
      }
      createdAt
      deleted
      district {
        code
        id
        name
      }
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      region {
        createdAt
        deleted
        id
        name
        updatedAt
      }
      state {
        code
        id
        name
      }
      taxNumber
      taxOffice
      title
      updatedAt
    }
    attributes {
      customerAttributeId
      customerAttributeOptionId
      value
    }
    birthDate
    createdAt
    customerGroupIds
    customerSegmentIds
    customerSequence
    deleted
    email
    emailVerifiedDate
    firstName
    fullName
    gender
    id
    isEmailVerified
    isPhoneVerified
    lastName
    note
    orderCount
    passwordUpdateDate
    phone
    phoneSubscriptionStatus
    phoneSubscriptionStatusUpdatedAt
    phoneVerifiedDate
    preferredLanguage
    priceListId
    priceListRules {
      discountRate
      filters {
        type
        valueList
      }
      priceListId
      shouldMatchAllFilters
      value
      valueType
    }
    registrationSource
    smsSubscriptionStatus
    smsSubscriptionStatusUpdatedAt
    subscriptionStatus
    subscriptionStatusUpdatedAt
    tagIds
    updatedAt
  }
}`;
export const CustomerRefreshToken = `mutation CustomerRefreshToken($token: String!) {
  customerRefreshToken(token: $token) {
    token
    tokenExpiry
  }
}`;
export const CustomerRecoverPassword = `mutation CustomerRecoverPassword($password: String!, $passwordAgain: String!, $token: String!) {
  customerRecoverPassword(password: $password, passwordAgain: $passwordAgain, token: $token)
}`;
export const CustomerLogin = `mutation CustomerLogin($email: String, $password: String) {
  customerLogin(email: $email, password: $password) {
    customer {
      accountStatus
      accountStatusUpdatedAt
      addresses {
        addressLine1
        addressLine2
        city {
          code
          id
          name
        }
        company
        country {
          code
          id
          iso2
          iso3
          name
        }
        createdAt
        deleted
        district {
          code
          id
          name
        }
        firstName
        id
        identityNumber
        isDefault
        lastName
        phone
        postalCode
        region {
          createdAt
          deleted
          id
          name
          updatedAt
        }
        state {
          code
          id
          name
        }
        taxNumber
        taxOffice
        title
        updatedAt
      }
      attributes {
        customerAttributeId
        customerAttributeOptionId
        value
      }
      birthDate
      createdAt
      customerGroupIds
      customerSegmentIds
      customerSequence
      deleted
      email
      emailVerifiedDate
      firstName
      fullName
      gender
      id
      isEmailVerified
      isPhoneVerified
      lastName
      note
      orderCount
      passwordUpdateDate
      phone
      phoneSubscriptionStatus
      phoneSubscriptionStatusUpdatedAt
      phoneVerifiedDate
      preferredLanguage
      priceListId
      priceListRules {
        discountRate
        filters {
          type
          valueList
        }
        priceListId
        shouldMatchAllFilters
        value
        valueType
      }
      registrationSource
      smsSubscriptionStatus
      smsSubscriptionStatusUpdatedAt
      subscriptionStatus
      subscriptionStatusUpdatedAt
      tagIds
      updatedAt
    }
    flowId
    otpSend
    token
    tokenExpiry
  }
}`;
export const RegisterCustomer = `mutation RegisterCustomer($email: String, $password: String, $firstName: String, $lastName: String, $phone: String) {
  registerCustomer(email: $email, password: $password, firstName: $firstName, lastName: $lastName, phone: $phone) {
    customer {
      accountStatus
      accountStatusUpdatedAt
      addresses {
        addressLine1
        addressLine2
        city {
          code
          id
          name
        }
        company
        country {
          code
          id
          iso2
          iso3
          name
        }
        createdAt
        deleted
        district {
          code
          id
          name
        }
        firstName
        id
        identityNumber
        isDefault
        lastName
        phone
        postalCode
        region {
          createdAt
          deleted
          id
          name
          updatedAt
        }
        state {
          code
          id
          name
        }
        taxNumber
        taxOffice
        title
        updatedAt
      }
      attributes {
        customerAttributeId
        customerAttributeOptionId
        value
      }
      birthDate
      createdAt
      customerGroupIds
      customerSegmentIds
      customerSequence
      deleted
      email
      emailVerifiedDate
      firstName
      fullName
      gender
      id
      isEmailVerified
      isPhoneVerified
      lastName
      note
      orderCount
      passwordUpdateDate
      phone
      phoneSubscriptionStatus
      phoneSubscriptionStatusUpdatedAt
      phoneVerifiedDate
      preferredLanguage
      priceListId
      priceListRules {
        discountRate
        filters {
          type
          valueList
        }
        priceListId
        shouldMatchAllFilters
        value
        valueType
      }
      registrationSource
      smsSubscriptionStatus
      smsSubscriptionStatusUpdatedAt
      subscriptionStatus
      subscriptionStatusUpdatedAt
      tagIds
      updatedAt
    }
    flowId
    otpSend
    token
    tokenExpiry
  }
}`;
export const SaveMyCustomer = `mutation SaveMyCustomer($input: SaveMyCustomerInput!) {
  saveMyCustomer(input: $input) {
    accountStatus
    accountStatusUpdatedAt
    addresses {
      addressLine1
      addressLine2
      city {
        code
        id
        name
      }
      company
      country {
        code
        id
        iso2
        iso3
        name
      }
      createdAt
      deleted
      district {
        code
        id
        name
      }
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      region {
        createdAt
        deleted
        id
        name
        updatedAt
      }
      state {
        code
        id
        name
      }
      taxNumber
      taxOffice
      title
      updatedAt
    }
    attributes {
      customerAttributeId
      customerAttributeOptionId
      value
    }
    birthDate
    createdAt
    customerGroupIds
    customerSegmentIds
    customerSequence
    deleted
    email
    emailVerifiedDate
    firstName
    fullName
    gender
    id
    isEmailVerified
    isPhoneVerified
    lastName
    note
    orderCount
    passwordUpdateDate
    phone
    phoneSubscriptionStatus
    phoneSubscriptionStatusUpdatedAt
    phoneVerifiedDate
    preferredLanguage
    priceListId
    priceListRules {
      discountRate
      filters {
        type
        valueList
      }
      priceListId
      shouldMatchAllFilters
      value
      valueType
    }
    registrationSource
    smsSubscriptionStatus
    smsSubscriptionStatusUpdatedAt
    subscriptionStatus
    subscriptionStatusUpdatedAt
    tagIds
    updatedAt
  }
}`;
export const CustomerForgotPassword = `mutation CustomerForgotPassword($email: String!) {
  customerForgotPassword(email: $email)
}`;
export const GetCustomerOrders = `query GetCustomerOrders {
  getCustomerOrders {
    billingAddress {
      addressLine1
      addressLine2
      city {
        code
        id
        name
      }
      company
      country {
        code
        id
        iso2
        iso3
        name
      }
      district {
        code
        id
        name
      }
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      region {
        createdAt
        deleted
        id
        name
        updatedAt
      }
      state {
        code
        id
        name
      }
      taxNumber
      taxOffice
    }
    cancelReason
    cancelledAt
    createdAt
    currencyCode
    currencyRates {
      code
      originalRate
      rate
    }
    currencySymbol
    customer {
      email
      firstName
      fullName
      id
      isGuestCheckout
      lastName
      notificationsAccepted
      phone
    }
    customerId
    deleted
    giftPackageLines {
      isRefunded
      price
      priceListId
      taxValue
    }
    giftPackageNote
    id
    invoices {
      appId
      appName
      createdAt
      hasPdf
      id
      invoiceData
      invoiceNumber
      storeAppId
      type
    }
    isGiftPackage
    merchantId
    note
    orderAdjustments {
      amount
      amountType
      appliedOrderLines {
        amount
        appliedQuantity
        isAutoCreated
        orderLineId
      }
      campaignId
      campaignType
      couponId
      name
      order
      transactionId
      type
    }
    orderLineItems {
      bundleProductSettings {
        bundleLineId
        bundleLineQuantity
        name
      }
      createdAt
      currencyCode
      currencySymbol
      customerSubscriptionPlan {
        id
      }
      deleted
      discount {
        amount
        amountType
        campaignOfferId
        campaignOfferProductId
        maxApplicableQuantity
        productVolumeDiscountId
        reason
      }
      discountPrice
      edited
      finalPrice
      finalUnitPrice
      id
      options {
        name
        productOptionId
        productOptionsSetId
        type
        values {
          applyAfterCampaign
          name
          price
          priceType
          value
        }
      }
      originalOrderLineItemId
      price
      quantity
      status
      statusUpdatedAt
      stockLocationId
      subscriptionPlan {
        id
        name
        period {
          cutOffDay
          discount {
            amount
            type
          }
          durationUnit
          durationValue
          id
          maxOrders
          paymentType
          scheduledOrderDay
          title
        }
      }
      taxValue
      unitPrice
      updatedAt
      variant {
        barcodeList
        baseUnit {
          baseAmount
          type
          unit {
            id
            name
          }
        }
        brand {
          id
          name
        }
        bundleProducts {
          addToBundleBasePrice
          deleted
          discountPrice
          discountRatio
          finalPrice
          finalUnitPrice
          id
          order
          price
          quantity
          taxValue
          unitPrice
          variant {
            barcodeList
            fileId
            hsCode
            id
            mainImageId
            name
            productId
            productVolumeDiscountId
            sku
            slug
            tagIds
            taxValue
            type
            weight
          }
        }
        categories {
          categoryPath {
            id
            name
          }
          id
          name
        }
        fileId
        hsCode
        id
        mainImageId
        name
        prices {
          buyPrice
          currency
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        productId
        productVolumeDiscountId
        sku
        slug
        tagIds
        tags {
          id
          name
        }
        taxValue
        type
        unit {
          amount
          type
        }
        variantValues {
          order
          variantTypeId
          variantTypeName
          variantValueId
          variantValueName
        }
        weight
      }
    }
    orderNumber
    orderPackageStatus
    orderPackages {
      createdAt
      deleted
      errorMessage
      id
      note
      orderLineItemIds
      orderPackageFulfillStatus
      orderPackageNumber
      refundReasonId
      sourceId
      stockLocationId
      subscriptionPlanOrder {
        customerSubscriptionPlanId
        customerSubscriptionPlanOrderId
        paymentDate
        paymentStatus
        plannedDate
        status
      }
      trackingInfo {
        barcode
        cargoCompany
        cargoCompanyId
        isSendNotification
        shippingLabelImage
        trackingLink
        trackingNumber
      }
      updatedAt
    }
    orderPaymentStatus
    orderTagIds
    orderedAt
    paymentMethods {
      isAlternativeGateway
      paymentGatewayCode
      paymentGatewayId
      paymentGatewayName
      price
      type
    }
    shippingAddress {
      addressLine1
      addressLine2
      company
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      taxNumber
      taxOffice
    }
    shippingLines {
      finalPrice
      isRefunded
      paymentMethod
      price
      priceListId
      shippingSettingsId
      shippingZoneRateId
      taxValue
      title
      transactionId
    }
    shippingMethod
    status
    taxLines {
      price
      rate
    }
    totalFinalPrice
    totalPrice
    updatedAt
  }
}`;

//CART
export const GetCart = `query GetCart($customerId: String, $getCartId: String) {
  getCart(customerId: $customerId, id: $getCartId) {
    campaignOffers {
      appliedOrderLineId
      campaignOfferId
      campaignOfferProductId
      offerEndDate
      offerStartDate
      status
      targetPageTypes
      triggerSourceOrderLineId
    }
    createdAt
    createdBy
    currencyCode
    currencySymbol
    customerId
    deleted
    dueDate
    id
    itemCount
    items {
      bundleProductSettings {
        bundleLineId
        bundleLineQuantity
        name
      }
      createdAt
      currencyCode
      currencySymbol
      customerSubscriptionPlan {
        id
      }
      deleted
      discount {
        amount
        amountType
        campaignOfferId
        campaignOfferProductId
        maxApplicableQuantity
        productVolumeDiscountId
        reason
      }
      discountPrice
      edited
      finalPrice
      finalUnitPrice
      id
      options {
        name
        productOptionId
        productOptionsSetId
        type
        values {
          applyAfterCampaign
          name
          price
          priceType
          value
        }
      }
      originalOrderLineItemId
      price
      quantity
      status
      statusUpdatedAt
      stockLocationId
      subscriptionPlan {
        id
        name
        period {
          cutOffDay
          discount {
            amount
            type
          }
          durationUnit
          durationValue
          id
          maxOrders
          paymentType
          scheduledOrderDay
          title
        }
      }
      taxValue
      unitPrice
      updatedAt
      variant {
        barcodeList
        baseUnit {
          baseAmount
          type
          unit {
            id
            name
          }
        }
        brand {
          id
          name
        }
        bundleProducts {
          addToBundleBasePrice
          deleted
          discountPrice
          discountRatio
          finalPrice
          finalUnitPrice
          id
          order
          price
          quantity
          taxValue
          unitPrice
          variant {
            barcodeList
            fileId
            hsCode
            id
            mainImageId
            name
            productId
            productVolumeDiscountId
            sku
            slug
            tagIds
            taxValue
            type
            weight
          }
        }
        categories {
          categoryPath {
            id
            name
          }
          id
          name
        }
        fileId
        hsCode
        id
        mainImageId
        name
        prices {
          buyPrice
          currency
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        productId
        productVolumeDiscountId
        sku
        slug
        tagIds
        tags {
          id
          name
        }
        taxValue
        type
        unit {
          amount
          type
        }
        variantValues {
          order
          variantTypeId
          variantTypeName
          variantValueId
          variantValueName
        }
        weight
      }
    }
    lastActivityDate
    merchantId
    priceListId
    salesChannelId
    status
    storefrontId
    storefrontRouting {
      domain
      dynamicCurrencySettings {
        roundingFormat
        targetCurrencyCode
        targetCurrencySymbol
      }
      id
      locale
      path
      priceListId
    }
    storefrontRoutingId
    storefrontThemeId
    taxLines {
      price
      rate
    }
    totalPrice
    updatedAt
  }
}`;
export const CreateCart = `mutation CreateCart($input: CreateCartInput!) {
  createCart(input: $input) {
    abandonedCartFlows {
      authorizedAppId
      campaignId
      canApplicable
      couponId
      customerFilters {
        sendOnlyActiveAccount
        sendOnlySubscribedToEmail
      }
      flowId
      mailSendDate
      mailTemplateId
      mailTranslationId
      messageType
      recoverEmailStatus
      sendAfter
      smsTranslationId
    }
    attributes {
      orderAttributeId
      orderAttributeOptionId
      value
    }
    availableShippingMethods {
      estimatedDeliveryTime {
        type
        value
      }
      price
      rateName
      shippingMethod
      shippingSettingsId
      shippingZoneRateId
    }
    billingAddress {
      addressLine1
      addressLine2
      city {
        code
        id
        name
      }
      company
      country {
        code
        id
        iso2
        iso3
        name
      }
      district {
        code
        id
        name
      }
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      region {
        createdAt
        deleted
        id
        name
        updatedAt
      }
      state {
        code
        id
        name
      }
      taxNumber
      taxOffice
    }
    campaignOffers {
      appliedOrderLineId
      campaignOffer {
        availableSalesChannelIds
        createdAt
        currencyCodes
        deleted
        endDate
        followUpActionType
        id
        maxCount
        maximumRequiredCartAmount
        minimumRequiredCartAmount
        name
        offers {
          applicablePrice
          countdownMinutes
          description
          discountAmount
          discountType
          excludedVariantIdList
          id
          order
          productId
          showCriteria
          skipOfferIfProductExistsInCart
          title
          translations {
            description
            locale
            title
          }
        }
        startDate
        targetPageTypes
        triggerSettings {
          filterType
          valueList
        }
        triggers {
          filters {
            filterType
            valueList
          }
          shouldMatchAllConditions
        }
        type
        updatedAt
      }
      campaignOfferId
      campaignOfferProductId
      offerEndDate
      offerStartDate
      status
      targetPageTypes
      triggerSourceOrderLineId
    }
    cartId
    cartStatus
    checkoutId
    clientIp
    couponCode
    createdAt
    createdBy
    currencyCode
    currencyRates {
      code
      originalRate
      rate
    }
    currencySymbol
    customer {
      email
      firstName
      fullName
      id
      isGuestCheckout
      lastName
      notificationsAccepted
      phone
    }
    customerGroups {
      id
      name
    }
    customerId
    customerSegments {
      id
      name
    }
    deleted
    dueDate
    giftCardLines {
      amount
      appliedTransactions {
        amount
        id
        type
      }
      code
      giftCardId
      id
      type
    }
    giftPackageLines {
      isRefunded
      price
      priceListId
      taxValue
    }
    giftPackageNote
    host
    id
    isGiftPackage
    itemCount
    lastActivityDate
    loyaltyLines {
      amount
      id
      loyaltyProgramCustomerId
      loyaltyProgramId
      loyaltySpendingMethodId
    }
    merchantId
    netTotalFinalPrice
    note
    orderAdjustments {
      amount
      amountType
      appliedOrderLines {
        amount
        appliedQuantity
        isAutoCreated
        orderLineId
      }
      campaignId
      campaignType
      couponId
      name
      order
      transactionId
      type
    }
    orderLineItems {
      bundleProductSettings {
        bundleLineId
        bundleLineQuantity
        name
      }
      createdAt
      currencyCode
      currencySymbol
      customerSubscriptionPlan {
        id
      }
      deleted
      discount {
        amount
        amountType
        campaignOfferId
        campaignOfferProductId
        maxApplicableQuantity
        productVolumeDiscountId
        reason
      }
      discountPrice
      edited
      finalPrice
      finalUnitPrice
      id
      options {
        name
        productOptionId
        productOptionsSetId
        type
        values {
          applyAfterCampaign
          name
          price
          priceType
          value
        }
      }
      originalOrderLineItemId
      price
      quantity
      status
      statusUpdatedAt
      stockLocationId
      subscriptionPlan {
        id
        name
        period {
          cutOffDay
          discount {
            amount
            type
          }
          durationUnit
          durationValue
          id
          maxOrders
          paymentType
          scheduledOrderDay
          title
        }
      }
      taxValue
      unitPrice
      updatedAt
      variant {
        barcodeList
        baseUnit {
          baseAmount
          type
          unit {
            id
            name
          }
        }
        brand {
          id
          name
        }
        bundleProducts {
          addToBundleBasePrice
          deleted
          discountPrice
          discountRatio
          finalPrice
          finalUnitPrice
          id
          order
          price
          quantity
          taxValue
          unitPrice
          variant {
            barcodeList
            fileId
            hsCode
            id
            mainImageId
            name
            productId
            productVolumeDiscountId
            sku
            slug
            tagIds
            taxValue
            type
            weight
          }
        }
        categories {
          categoryPath {
            id
            name
          }
          id
          name
        }
        fileId
        hsCode
        id
        mainImageId
        name
        prices {
          buyPrice
          currency
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        productId
        productVolumeDiscountId
        sku
        slug
        tagIds
        tags {
          id
          name
        }
        taxValue
        type
        unit {
          amount
          type
        }
        variantValues {
          order
          variantTypeId
          variantTypeName
          variantValueId
          variantValueName
        }
        weight
      }
    }
    orderNumber
    orderPackageStatus
    orderPaymentStatus
    orderedAt
    priceListId
    recoverEmailStatus
    recoveryStatus
    salesChannelId
    sessionId
    sessionInfo {
      countryCode
      durationMS
      end
      host
      ip
      journeyId
      referer
      salesChannelId
      sessionId
      start
      storefrontId
      trafficSource {
        source
        type
      }
      userAgent {
        deviceType
        name
        os
      }
      utm {
        campaign
        content
        medium
        source
        term
      }
      visitorId
    }
    shippingAddress {
      addressLine1
      addressLine2
      company
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      taxNumber
      taxOffice
    }
    shippingLines {
      finalPrice
      isRefunded
      paymentMethod
      price
      priceListId
      shippingSettingsId
      shippingZoneRateId
      taxValue
      title
      transactionId
    }
    shippingMethod
    shippingSettingsId
    shippingZoneRateId
    status
    stockLocationId
    storefrontId
    storefrontRouting {
      domain
      dynamicCurrencySettings {
        roundingFormat
        targetCurrencyCode
      }
      id
      locale
      path
      priceListId
      salesChannelId
    }
    storefrontRoutingId
    storefrontThemeId
    taxLines {
      price
      rate
    }
    totalFinalPrice
    totalPrice
    updatedAt
    userAgent
  }
}`;
export const AddItemToCart = `mutation AddItemToCart($input: AddItemToCartInput!) {
  addItemToCart(input: $input) {
    abandonedCartFlows {
      authorizedAppId
      campaignId
      canApplicable
      couponId
      customerFilters {
        sendOnlyActiveAccount
        sendOnlySubscribedToEmail
      }
      flowId
      mailSendDate
      mailTemplateId
      mailTranslationId
      messageType
      recoverEmailStatus
      sendAfter
      smsTranslationId
    }
    attributes {
      orderAttributeId
      orderAttributeOptionId
      value
    }
    availableShippingMethods {
      estimatedDeliveryTime {
        type
        value
      }
      price
      rateName
      shippingMethod
      shippingSettingsId
      shippingZoneRateId
    }
    billingAddress {
      addressLine1
      addressLine2
      city {
        code
        id
        name
      }
      company
      country {
        code
        id
        iso2
        iso3
        name
      }
      district {
        code
        id
        name
      }
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      region {
        createdAt
        deleted
        id
        name
        updatedAt
      }
      state {
        code
        id
        name
      }
      taxNumber
      taxOffice
    }
    campaignOffers {
      appliedOrderLineId
      campaignOffer {
        availableSalesChannelIds
        createdAt
        currencyCodes
        deleted
        endDate
        followUpActionType
        id
        maxCount
        maximumRequiredCartAmount
        minimumRequiredCartAmount
        name
        offers {
          applicablePrice
          countdownMinutes
          description
          discountAmount
          discountType
          excludedVariantIdList
          id
          order
          productId
          showCriteria
          skipOfferIfProductExistsInCart
          title
          translations {
            description
            locale
            title
          }
        }
        startDate
        targetPageTypes
        triggerSettings {
          filterType
          valueList
        }
        triggers {
          filters {
            filterType
            valueList
          }
          shouldMatchAllConditions
        }
        type
        updatedAt
      }
      campaignOfferId
      campaignOfferProductId
      offerEndDate
      offerStartDate
      status
      targetPageTypes
      triggerSourceOrderLineId
    }
    cartId
    cartStatus
    checkoutId
    clientIp
    couponCode
    createdAt
    createdBy
    currencyCode
    currencyRates {
      code
      originalRate
      rate
    }
    currencySymbol
    customer {
      email
      firstName
      fullName
      id
      isGuestCheckout
      lastName
      notificationsAccepted
      phone
    }
    customerGroups {
      id
      name
    }
    customerId
    customerSegments {
      id
      name
    }
    deleted
    dueDate
    giftCardLines {
      amount
      appliedTransactions {
        amount
        id
        type
      }
      code
      giftCardId
      id
      type
    }
    giftPackageLines {
      isRefunded
      price
      priceListId
      taxValue
    }
    giftPackageNote
    host
    id
    isGiftPackage
    itemCount
    lastActivityDate
    loyaltyLines {
      amount
      id
      loyaltyProgramCustomerId
      loyaltyProgramId
      loyaltySpendingMethodId
    }
    merchantId
    netTotalFinalPrice
    note
    orderAdjustments {
      amount
      amountType
      appliedOrderLines {
        amount
        appliedQuantity
        isAutoCreated
        orderLineId
      }
      campaignId
      campaignType
      couponId
      name
      order
      transactionId
      type
    }
    orderLineItems {
      bundleProductSettings {
        bundleLineId
        bundleLineQuantity
        name
      }
      createdAt
      currencyCode
      currencySymbol
      customerSubscriptionPlan {
        id
      }
      deleted
      discount {
        amount
        amountType
        campaignOfferId
        campaignOfferProductId
        maxApplicableQuantity
        productVolumeDiscountId
        reason
      }
      discountPrice
      edited
      finalPrice
      finalUnitPrice
      id
      options {
        name
        productOptionId
        productOptionsSetId
        type
        values {
          applyAfterCampaign
          name
          price
          priceType
          value
        }
      }
      originalOrderLineItemId
      price
      quantity
      status
      statusUpdatedAt
      stockLocationId
      subscriptionPlan {
        id
        name
        period {
          cutOffDay
          discount {
            amount
            type
          }
          durationUnit
          durationValue
          id
          maxOrders
          paymentType
          scheduledOrderDay
          title
        }
      }
      taxValue
      unitPrice
      updatedAt
      variant {
        barcodeList
        baseUnit {
          baseAmount
          type
          unit {
            id
            name
          }
        }
        brand {
          id
          name
        }
        bundleProducts {
          addToBundleBasePrice
          deleted
          discountPrice
          discountRatio
          finalPrice
          finalUnitPrice
          id
          order
          price
          quantity
          taxValue
          unitPrice
          variant {
            barcodeList
            fileId
            hsCode
            id
            mainImageId
            name
            productId
            productVolumeDiscountId
            sku
            slug
            tagIds
            taxValue
            type
            weight
          }
        }
        categories {
          categoryPath {
            id
            name
          }
          id
          name
        }
        fileId
        hsCode
        id
        mainImageId
        name
        prices {
          buyPrice
          currency
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        productId
        productVolumeDiscountId
        sku
        slug
        tagIds
        tags {
          id
          name
        }
        taxValue
        type
        unit {
          amount
          type
        }
        variantValues {
          order
          variantTypeId
          variantTypeName
          variantValueId
          variantValueName
        }
        weight
      }
    }
    orderNumber
    orderPackageStatus
    orderPaymentStatus
    orderedAt
    priceListId
    recoverEmailStatus
    recoveryStatus
    salesChannelId
    sessionId
    sessionInfo {
      countryCode
      durationMS
      end
      host
      ip
      journeyId
      referer
      salesChannelId
      sessionId
      start
      storefrontId
      trafficSource {
        source
        type
      }
      userAgent {
        deviceType
        name
        os
      }
      utm {
        campaign
        content
        medium
        source
        term
      }
      visitorId
    }
    shippingAddress {
      addressLine1
      addressLine2
      company
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      taxNumber
      taxOffice
    }
    shippingLines {
      finalPrice
      isRefunded
      paymentMethod
      price
      priceListId
      shippingSettingsId
      shippingZoneRateId
      taxValue
      title
      transactionId
    }
    shippingMethod
    shippingSettingsId
    shippingZoneRateId
    status
    stockLocationId
    storefrontId
    storefrontRouting {
      domain
      dynamicCurrencySettings {
        roundingFormat
        targetCurrencyCode
      }
      id
      locale
      path
      priceListId
      salesChannelId
    }
    storefrontRoutingId
    storefrontThemeId
    taxLines {
      price
      rate
    }
    totalFinalPrice
    totalPrice
    updatedAt
    userAgent
  }
}`;
export const SaveCart = `mutation SaveCart($input: SaveCartInput!) {
  saveCart(input: $input) {
    abandonedCartFlows {
      authorizedAppId
      campaignId
      canApplicable
      couponId
      customerFilters {
        sendOnlyActiveAccount
        sendOnlySubscribedToEmail
      }
      flowId
      mailSendDate
      mailTemplateId
      mailTranslationId
      messageType
      recoverEmailStatus
      sendAfter
      smsTranslationId
    }
    attributes {
      orderAttributeId
      orderAttributeOptionId
      value
    }
    availableShippingMethods {
      estimatedDeliveryTime {
        type
        value
      }
      price
      rateName
      shippingMethod
      shippingSettingsId
      shippingZoneRateId
    }
    billingAddress {
      addressLine1
      addressLine2
      city {
        code
        id
        name
      }
      company
      country {
        code
        id
        iso2
        iso3
        name
      }
      district {
        code
        id
        name
      }
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      region {
        createdAt
        deleted
        id
        name
        updatedAt
      }
      state {
        code
        id
        name
      }
      taxNumber
      taxOffice
    }
    campaignOffers {
      appliedOrderLineId
      campaignOffer {
        availableSalesChannelIds
        createdAt
        currencyCodes
        deleted
        endDate
        followUpActionType
        id
        maxCount
        maximumRequiredCartAmount
        minimumRequiredCartAmount
        name
        offers {
          applicablePrice
          countdownMinutes
          description
          discountAmount
          discountType
          excludedVariantIdList
          id
          order
          productId
          showCriteria
          skipOfferIfProductExistsInCart
          title
          translations {
            description
            locale
            title
          }
        }
        startDate
        targetPageTypes
        triggerSettings {
          filterType
          valueList
        }
        triggers {
          filters {
            filterType
            valueList
          }
          shouldMatchAllConditions
        }
        type
        updatedAt
      }
      campaignOfferId
      campaignOfferProductId
      offerEndDate
      offerStartDate
      status
      targetPageTypes
      triggerSourceOrderLineId
    }
    cartId
    cartStatus
    checkoutId
    clientIp
    couponCode
    createdAt
    createdBy
    currencyCode
    currencyRates {
      code
      originalRate
      rate
    }
    currencySymbol
    customer {
      email
      firstName
      fullName
      id
      isGuestCheckout
      lastName
      notificationsAccepted
      phone
    }
    customerGroups {
      id
      name
    }
    customerId
    customerSegments {
      id
      name
    }
    deleted
    dueDate
    giftCardLines {
      amount
      appliedTransactions {
        amount
        id
        type
      }
      code
      giftCardId
      id
      type
    }
    giftPackageLines {
      isRefunded
      price
      priceListId
      taxValue
    }
    giftPackageNote
    host
    id
    isGiftPackage
    itemCount
    lastActivityDate
    loyaltyLines {
      amount
      id
      loyaltyProgramCustomerId
      loyaltyProgramId
      loyaltySpendingMethodId
    }
    merchantId
    netTotalFinalPrice
    note
    orderAdjustments {
      amount
      amountType
      appliedOrderLines {
        amount
        appliedQuantity
        isAutoCreated
        orderLineId
      }
      campaignId
      campaignType
      couponId
      name
      order
      transactionId
      type
    }
    orderLineItems {
      bundleProductSettings {
        bundleLineId
        bundleLineQuantity
        name
      }
      createdAt
      currencyCode
      currencySymbol
      customerSubscriptionPlan {
        id
      }
      deleted
      discount {
        amount
        amountType
        campaignOfferId
        campaignOfferProductId
        maxApplicableQuantity
        productVolumeDiscountId
        reason
      }
      discountPrice
      edited
      finalPrice
      finalUnitPrice
      id
      options {
        name
        productOptionId
        productOptionsSetId
        type
        values {
          applyAfterCampaign
          name
          price
          priceType
          value
        }
      }
      originalOrderLineItemId
      price
      quantity
      status
      statusUpdatedAt
      stockLocationId
      subscriptionPlan {
        id
        name
        period {
          cutOffDay
          discount {
            amount
            type
          }
          durationUnit
          durationValue
          id
          maxOrders
          paymentType
          scheduledOrderDay
          title
        }
      }
      taxValue
      unitPrice
      updatedAt
      variant {
        barcodeList
        baseUnit {
          baseAmount
          type
          unit {
            id
            name
          }
        }
        brand {
          id
          name
        }
        bundleProducts {
          addToBundleBasePrice
          deleted
          discountPrice
          discountRatio
          finalPrice
          finalUnitPrice
          id
          order
          price
          quantity
          taxValue
          unitPrice
          variant {
            barcodeList
            fileId
            hsCode
            id
            mainImageId
            name
            productId
            productVolumeDiscountId
            sku
            slug
            tagIds
            taxValue
            type
            weight
          }
        }
        categories {
          categoryPath {
            id
            name
          }
          id
          name
        }
        fileId
        hsCode
        id
        mainImageId
        name
        prices {
          buyPrice
          currency
          currencySymbol
          discountPrice
          priceListId
          sellPrice
          unitPrice
        }
        productId
        productVolumeDiscountId
        sku
        slug
        tagIds
        tags {
          id
          name
        }
        taxValue
        type
        unit {
          amount
          type
        }
        variantValues {
          order
          variantTypeId
          variantTypeName
          variantValueId
          variantValueName
        }
        weight
      }
    }
    orderNumber
    orderPackageStatus
    orderPaymentStatus
    orderedAt
    priceListId
    recoverEmailStatus
    recoveryStatus
    salesChannelId
    sessionId
    sessionInfo {
      countryCode
      durationMS
      end
      host
      ip
      journeyId
      referer
      salesChannelId
      sessionId
      start
      storefrontId
      trafficSource {
        source
        type
      }
      userAgent {
        deviceType
        name
        os
      }
      utm {
        campaign
        content
        medium
        source
        term
      }
      visitorId
    }
    shippingAddress {
      addressLine1
      addressLine2
      company
      firstName
      id
      identityNumber
      isDefault
      lastName
      phone
      postalCode
      taxNumber
      taxOffice
    }
    shippingLines {
      finalPrice
      isRefunded
      paymentMethod
      price
      priceListId
      shippingSettingsId
      shippingZoneRateId
      taxValue
      title
      transactionId
    }
    shippingMethod
    shippingSettingsId
    shippingZoneRateId
    status
    stockLocationId
    storefrontId
    storefrontRouting {
      domain
      dynamicCurrencySettings {
        roundingFormat
        targetCurrencyCode
      }
      id
      locale
      path
      priceListId
      salesChannelId
    }
    storefrontRoutingId
    storefrontThemeId
    taxLines {
      price
      rate
    }
    totalFinalPrice
    totalPrice
    updatedAt
    userAgent
  }
}`;

//OTHERS
export const ListCity = `query ListCity($stateId: StringFilterInput!) {
  listCity(stateId: $stateId) {
    cityCode
    countryId
    createdAt
    deleted
    id
    latitude
    longitude
    name
    order
    stateId
    updatedAt
  }
}`;
export const ListCountry = `query ListCountry {
  listCountry {
    capital
    createdAt
    currency
    currencyCode
    currencySymbol
    deleted
    emoji
    emojiString
    id
    iso2
    iso3
    locationTranslations {
      de
      en
      fr
      tr
    }
    name
    native
    phoneCode
    region
    subregion
    updatedAt
  }
}`;
export const ListDistrict = `query ListDistrict($cityId: StringFilterInput!) {
  listDistrict(cityId: $cityId) {
    cityId
    countryId
    createdAt
    deleted
    id
    latitude
    longitude
    name
    order
    stateId
    updatedAt
  }
}`;
